<template>
  <div class="cordel-field">
    <form-label
      v-if="label && !labelless"
      :errors="errors"
      :loading="loading"
      :disabled="disabled"
      :required="required"
      :name="name"
      @click="click"
    >
      {{ label }}
    </form-label>

    <span
      :is="is"

      ref="element"

      v-bind="attributes"

      :name="name"

      :disabled="loading || disabled"
      :loading="loading"
      :errors="errors"

      :value="value"
      :icon="icon"

      @input="input"
      @search="search"
      @keydown.ctrl.v="paste"
      @keydown.meta.v="paste"
      @blur="blur"
      @focus="focus"
      @change="change"
      @validate="validate"
    />

    <form-errors :errors="errors" />
  </div>
</template>

<script>
  import VALIDATORS from '@cordel/helpers/form/validators/_index';

  import monetize from '@sdk/helpers/formatters/monetize';
  import patternize from '@sdk/helpers/formatters/patternize';

  import FormErrors from './Errors.vue';

  import FormBoolean from './Boolean.vue';
  import FormInput from './Input.vue';
  import FormLabel from './Label.vue';
  import FormSelect from './Select.vue';
  import FormTextarea from './Textarea.vue';

  const MASKS = {
    monetize,
    patternize,
  };

  export default {
    name: 'CordelField',
    components: {
      FormErrors,

      FormBoolean,
      FormInput,
      FormLabel,
      FormSelect,

      FormTextarea,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Number, Boolean],
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      labelless: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: null,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      mask: {
        type: Object,
        default() {
          return {};
        },
      },
      type: {
        type: String,
        default: '',
      },
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
      validations: {
        type: Array,
        default() {
          return [];
        },
      },
      callback: {
        type: Function,
        default() {
          return () => {};
        },
      },
      options: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      is() {
        switch (this.type) {
          case 'select':
            return 'form-select';
          case 'boolean':
          case 'radio':
            return 'form-boolean';
          case 'textarea':
            return 'form-textarea';
          default:
            return 'form-input';
        }
      },
      required() {
        return !!this.validations.find(v => v.type === 'blank');
      },
      attributes() {
        const {
          label,
          placeholder,
          mask,
          options,
        } = this;

        switch (this.type) {
          case 'select':
            return {
              label,
              placeholder,
              options,
            };
          case 'boolean':
          case 'radio':
            return {
              options,
            };
          default:
            return {
              typed: this.type,
              placeholder,
              mask,
            };
        }
      },
    },
    methods: {
      paste(e) {
        setTimeout(() => {
          this.$emit('paste', e);
        }, 1000);
      },
      input(value) {
        this.$emit('input', value);
      },
      search(value) {
        this.$emit('search', value);
      },
      change(e) {
        this.$emit('change', e);
        this.$nextTick(this.validate);
      },
      blur(e) {
        this.$emit('blur', e);
        this.$nextTick(this.validate);
      },
      focus(e) {
        this.$emit('focus', e);
      },
      click(e) {
        if (this.type === 'boolean') {
          e.preventDefault();
          this.$refs.element.activate();
        }
      },
      validate() {
        const options = {
          formatter: MASKS[this.mask.type],
        };

        const form = this.$parent.$parent;

        const errors = this.validations
          .filter(validation => VALIDATORS[validation.type].call(form, this.value, {
            ...options,
            ...validation,
          }));

        this.$emit('validation', errors
          .map(validation => VALIDATORS[validation.type]
            .message.call(form, this.value, {
              ...options,
              ...validation,
            })));

        return errors;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-field {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
</style>
